import Vue from 'vue';
import VueRouter from 'vue-router';
import VueSmoothScroll from 'vue2-smooth-scroll';
import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);
Vue.use(VueSmoothScroll);

const routes = [
  {
    path: '/',
    component: HomeView,
  },
  {
    path: '/jukebox',
    component: () => import('../views/JukeboxView.vue'),
  },
  {
    path: '/info',
    component: () => import('../views/InfoView.vue'),
  },
  {
    path: '/search-music',
    component: () => import('../views/SearchMusicView.vue'),
  },
  {
    path: '/sources',
    component: () => import('../views/SourcesView.vue'),
  },
  {
    path: '/how-to-search',
    component: () => import('../views/HowToSearchView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
